import React, { useState } from 'react';
import styled from 'styled-components';
import { API_URL } from "../../constants";
const apiUrl = process.env.API_URL || API_URL;


const NotifyWrap = styled.div`
    position: relative; /* anchors the X button to the form, not the card */
    padding-left: 20px;
    margin-bottom: 15px;
    margin-top: 15px;
    width: 100%;

    &.action-button:hover { 
        background: transparent !important;
    }

    .input-bot-honeypot {
        width: 0;
        height: 0;
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    &.hide-notify {
        display: none !important;
    }

    .cult-button {
        width: 100%;
        font-size: 12px;
        @media (max-width: 767px) { font-size: 10px; }
    }

    // BACK BUTTON : sits at the right end of the email input
    button.cult-button.back-button {
        width: 40px;
        padding: 6px 0px 6px 3px;
        text-align: center;
        position: absolute;
        top: 0;
        right: 0;

        &.hide {
            display: none !important;
        }
    }

    input.email {
        width: 100%;
        box-shadow: 0 0 12px #000000bf;
        border-radius: 0;
        border: 1px solid #333;
        border-bottom-width: 0;
        outline: none;
        padding-right: 43px;
    }

    input::placeholder {
        padding-left: 20px;
        text-align: center;
    }

    .notify-submit-button {
        &:disabled {
            background: #999;
            pointer-events: none;
        }
    }

    .status-message {
        height: 100%;
        margin-bottom: 0;
        display: flex;
        align-content: center;
        justify-content: center;
    }
`;

const ShopNotify = ({ showInput = false, toggleNotify, selectedVariantId = '', product = '' }) => {
    const [email, setEmail] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [isFinishedSucessfully, setIsFinishedSucessfully] = useState(false);

    const setStatusMessageWithTimeout = (message) => {
        setStatusMessage(message);
        const timeoutId = setTimeout(() => {
            setStatusMessage('');
            setIsSubmitting(false);
        }, 3000);

        return () => clearTimeout(timeoutId);
    };

    const handleInputChange = (event) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(event.target.value)) {
            setIsSubmitting(false);
        } else {
            setIsSubmitting(true);
        }
        setEmail(event.target.value);
    };

    // FETCH : POST - Get notified when a product comes back in stock
    const submitNotifyRequest = async (email, selectedVariantId, productId, productTitle, productSize = '') => {
      return fetch(`${apiUrl}/store/notifyme`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          selectedVariantId,
          productId,
          productTitle,
          productSize
        })
      }).then( r => {
        return r.json();
      }).catch(err => {
        console.log( `ERROR : ${err}` )
      });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        if (!email) {
            setStatusMessageWithTimeout('Email is required');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setStatusMessageWithTimeout('Email is invalid');
            return;
        }

        if (!selectedVariantId) {
            setStatusMessageWithTimeout('Select a size');
            return;
        }

        // SIZE - Find the variant size when applicable or fill with N/A if not applicable
        const variantObj = product?.variants?.find(variant => variant.id === selectedVariantId);
        const size = variantObj?.title || 'N/A'; // Title or option1 both work as I set them the same in Shopify


        // SUBMIT - Send the request all fields look good
        try {
            // console.log( `PRODUCT INFO: \n  -- Email: ${email}\n  -- Selected Variant ID: ${selectedVariantId}\n  -- Parent ID: ${product.id}\n  -- Title: ${product.title}\n  -- Size: ${size}`)
            const response = await submitNotifyRequest( email, selectedVariantId, product.id, product.title, size)
            if (response?.code === 200) {
                setStatusMessage(`You're all set!`); //Intentionally dont revert back the form once successful
                setIsFinishedSucessfully(true);
            } else {
                setStatusMessageWithTimeout('Error - try again later');
            }
        } catch (error) {
            console.log( error );
            setStatusMessageWithTimeout('Error - try again later');
        }
    };




    return (
        <NotifyWrap className={`${showInput ? '' : 'hide-notify'}`}>
            <div id="mc_embed_signup">
                <form 
                    onSubmit={handleSubmit} 
                    id="mc-embedded-subscribe-form" 
                    name="mc-embedded-subscribe-form" 
                    className="validate" 
                    target="_self" 
                    noValidate>

                    <div id="mc_embed_signup_scroll">
                        {!statusMessage &&
                            <div className="mc-field-group">
                                {/* <label htmlFor="mce-EMAIL">Email Address <span className="asterisk">*</span></label> */}
                                <input 
                                    type="email" 
                                    name="EMAIL" 
                                    className="required email" 
                                    placeholder='Email Address'
                                    id="mce-EMAIL" 
                                    required 
                                    value={email} 
                                    onChange={handleInputChange} 
                                />
                            </div>
                        }     
                        
                        {/* CLOSE BUTTON (X) */}
                        <button 
                            className={`cult-button back-button ${isFinishedSucessfully ? 'hide': ''}`}
                            aria-label="Close notify form"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent form submission
                                toggleNotify();
                            }}>X
                        </button>

                        {/* MESSAGE COMPONENT */}
                        <div id="mce-responses" className="clear foot">
                            <div className="response" id="mce-error-response"></div>
                            <div className="response" id="mce-success-response"></div>
                        </div>

                        <div className="input-bot-honeypot" aria-hidden="true">
                            <input type="text" name="b_866ca475a871059129ab4dd57_5bb2989544" tabIndex="-1" value="" readOnly />
                        </div>

                        {/* STATUS MESSAGE TO USER */}
                        {!statusMessage &&
                            <div className="button-row-notify">
                                <button 
                                    type="submit" 
                                    className="cult-button button notify-submit-button" 
                                    disabled={isSubmitting}>Submit</button>
                            </div>
                        }
                    </div>
                </form>
                {statusMessage && <p className='status-message'>{statusMessage}</p>}
            </div>
        </NotifyWrap>
    );
};

export default ShopNotify;





